module.exports = __webpack_public_path__ + "img/vetted-for-you.9388d22a.svg";